import { store } from '@prodelio/config/state/store';

export const getProject = (id: string) => {
  return store.getState().projects.find((project) => id === project.id);
};
